<!--
 * @Author: zly
 * @Date: 2021-08-06 09:16:49
 * @LastEditTime: 2022-01-21 13:12:03
 * @LastEditors: zly
 * @Description:
-->
<template>
  <!--banner-->
  <div class="about">
    <div class="container" style="height: 40px; line-height: 40px;color: #999">
      <i class="iconfont icon-ziyuan"></i>&nbsp;
      <span class="font_link_fw"><router-link to="/">首页</router-link></span>
      &nbsp;&nbsp;>&nbsp;&nbsp;
      <span>品牌介绍</span>
    </div>
    <!--<div class="block banner" style="height: 150px;"></div>-->
    <div class="container" style=" margin-top: 30px; margin-bottom: 20px">
      <h1 style="text-align: center">关于宁东工业超市</h1>
      <div class="txtp">
        按照宁东能源化工基地管委会工作部署，宁夏宁东科技创业投资有限公司负责宁东工业互联网平台建设运营工作，宁东工业超市作为宁东工业互联网平台建设运营的重要一环，是2022年科创公司与中控PLANTMATE品牌合作建设电子商务平台。宁东工业超市依托深厚的科研积淀、强大的自主创新能力、全方位的专业服务团队和专家团队，核心理念是“价值·伴侣”。价值理念包括对用户现存需求的满足，更包括对面向用户潜在需求的挖掘，从而由浅至深的逐步实现创造价值和成就价值，且循环不断、源源不绝；伴侣理念以伙伴为起点，通过优质和持续的服务将产品和解决方案的功效发挥到极致，与用户建立持久、稳固的关系，从而一步步升华为性情相投、心心相印的伴侣，达到意识形态上的共鸣和行动上的同步，互相依存、实现共赢，这也是品牌希望与客户达到的极致关系。
      </div>
      <div class="txtp">
        宁东工业超市是为客户成就价值为导向的，面向流程工业解决方案的，全生命周期管理5S一站式服务平台。包括面向流程工业自动化领域工业控制、现场仪表系列产品、策略咨询、工程实施、诊断指导、运维保障等数字化智能化整体解决方案构成的全覆盖要素，
        助力工业企业客户达到优秀，走向卓越，共建智能化自动化产业新生态。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about'
}
</script>

<style scoped>
.about{
  height: calc(100vh - 524px);
}
.txtp {
  font-size: 14px;
  line-height: 24px;
  text-indent: 28px;
}
.banner {
  background: url('../../../assets/img/jjbanner.jpg') no-repeat top center;
  background-size: 100% 150px;
}
.font_link_fw a {
  color: #666;
}
.font_link_fw a:hover {
  color: #666;
}
</style>
